import { FC } from 'react'
import { useAmountAndCurrency } from '../../../../shared/useAmountAndCurrency'
import { useAuth } from '../../../../context/auth-context'
import PerButtonCircle from '../../../../components/custom_components/ButtonCircle'
import { useDateTime } from '../../../../shared/useDateTime'
import { ProrataPartial } from './targetBonusCalculation-util'
import PerText from '../../../../components/custom_components/Text'
import { Currency } from '../../../../types'
import { useTranslation } from 'react-i18next'
import { TimeZoneAndLocale } from '../../../../types.custom'

interface Props {
  prorataPartials: ProrataPartial[]
  currency: Currency
  employeeTimezone: string
  displayOnlyText?: boolean
}

export const ProrataTooltip: FC<Props> = ({ prorataPartials, currency, employeeTimezone, displayOnlyText = false }) => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const { formatCurrency } = useAmountAndCurrency(user.locale)
  const timezoneAndLocale: TimeZoneAndLocale = { timezone: employeeTimezone, locale: user.locale }
  const { formatDateShort } = useDateTime(timezoneAndLocale)

  const getProrataDescriptionString = (prorataPartials: ProrataPartial[]): JSX.Element => {
    const separator = t('appraisalMeeting.prorataTooltip.separator')
    return (
      <>
        <div>{t('appraisalMeeting.prorataTooltip.heading')}</div>
        <div>
          {prorataPartials.map((p, index) => (
            <div key={index}>
              {t('appraisalMeeting.prorataTooltip.partialCalcDescription', {
                amount: formatCurrency(p.amount, currency, true),
                annualAmount: formatCurrency(p.annualAmount, currency, true),
                date: formatDateShort(p.from),
              })}
              {index === prorataPartials.length - 1 || displayOnlyText ? '' : separator}
            </div>
          ))}
        </div>
      </>
    )
  }

  return !displayOnlyText ? (
    <PerButtonCircle
      icon="info_fill"
      size="xsmall"
      color="white"
      variant="gray-variant"
      className="disable-shadow"
      style={{ marginTop: '-2px' }}
      tooltip={
        <PerText color="white" fontSize="xs">
          {getProrataDescriptionString(prorataPartials)}
        </PerText>
      }
    />
  ) : (
    <PerText color="secondary" fontSize="xs">
      {getProrataDescriptionString(prorataPartials)}
    </PerText>
  )
}
